/* Custom interactions only. Shopify's Google channel owns ecommerce/page views. */
(() => {
  const id=document.currentScript?.dataset.ga4Id;
  if(!/^G-[A-Z0-9]+$/.test(id||''))return;
  const events=new Set(['quote_started','quote_submitted','spec_builder_change','finder_search','phone_click','shop_click','download']);
  const allowed=()=>window.Shopify?.customerPrivacy?.analyticsProcessingAllowed()===true;
  let initialized=false,ownsConsent=false;
  // Use the Google tag command format (Arguments), not a plain Array.
  function tag(){(window.dataLayer=window.dataLayer||[]).push(arguments);}
  const cleanUrl=value=>{try{const u=new URL(value,location.origin);return u.origin+u.pathname;}catch(_){return '';}};
  function init(){
    if(initialized)return;initialized=true;
    const configured=(window.dataLayer||[]).some(command=>command?.[0]==='config'&&command?.[1]===id);
    if(configured)return;
    const hasLoader=Array.from(document.scripts).some(script=>{try{const url=new URL(script.src);return url.hostname==='www.googletagmanager.com'&&url.pathname==='/gtag/js'&&(!url.searchParams.has('l')||url.searchParams.get('l')==='dataLayer');}catch(_){return false;}});
    ownsConsent=!hasLoader;
    if(ownsConsent){
      tag('consent','default',{analytics_storage:'denied',ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'});
      tag('consent','update',{analytics_storage:'granted'});
    }
    tag('js',new Date());
    tag('config',id,{send_page_view:false,allow_google_signals:false,allow_ad_personalization_signals:false,page_location:cleanUrl(location.href),page_referrer:cleanUrl(document.referrer)});
    if(!hasLoader){
      const script=document.createElement('script');script.async=true;
      script.src=`https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
      document.head.append(script);
    }
  }
  window.gapTrack=(name,properties={})=>{
    if(!events.has(name)||!allowed())return;
    init();
    const data={send_to:id,page_location:cleanUrl(location.href),page_referrer:cleanUrl(document.referrer)};
    if(name==='finder_search'&&Number.isInteger(properties.result_count))data.result_count=Math.max(0,properties.result_count);
    tag('event',name,data);
  };
  document.addEventListener('visitorConsentCollected',()=>{
    if(initialized&&ownsConsent)tag('consent','update',{analytics_storage:allowed()?'granted':'denied'});
  });
  if(!window.Shopify?.customerPrivacy)window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}],()=>{});
  document.addEventListener('click',event=>{
    const link=event.target.closest?.('a[href]');if(!link)return;
    if(link.hasAttribute('download')||/\.pdf(?:[?#]|$)/i.test(link.getAttribute('href')))window.gapTrack('download');
  });
})();
